import { AuthLayout } from "../components/ui/auth-layout"
import { ForgotPasswordForm } from "../components/auth/forgot-password-form"

export default function ForgotPasswordPage() {
  return (
    <AuthLayout title="Welcome Back" subtitle="Sign in to your VirtualScribe account" showBackButton={true}>
      <ForgotPasswordForm />
    </AuthLayout>
  )
}
